import { EmailOptInRepository, IEmailOptInPayload } from '../repositories/EmailOptInRepository';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';
import { AUTH_SOURCE } from '../constants/EmailOptIn';

export class EmailOptInRequestUseCase {
    private emailOptInRepository: EmailOptInRepository;
    private payload: IEmailOptInPayload;

    constructor(payload: IEmailOptInPayload) {
        this.emailOptInRepository = diContainer.get(serviceNames.emailOptInRepository);
        this.payload = payload;
    }

    public execute = async () => {
        try {
            const directOptInSources = [
                AUTH_SOURCE.SIGN_UP,
                AUTH_SOURCE.CHECKOUT_GUEST,
                AUTH_SOURCE.APPOINTMENT_BOOKED_GUEST
            ];
            // @ts-ignore
            if (directOptInSources.indexOf(this.payload.source) > -1) {
                await this.emailOptInRepository.emailOptInRequest(this.payload);
            } else {
                const email = this.emailOptInRepository.getUserEmail(this.payload);

                return await this.emailOptInRepository.getEmailOptInRequest(email);
            }
        } catch (error) {
            console.error(error);
        }
    };
}
